import {baseDevConfig} from './dev.config';
import * as extendUtils from '../../../utils/object/extend.utils';
import {PrismConfigOptions} from '../environment-variables.interface';

export const baseQaConfig: PrismConfigOptions = extendUtils.deepExtend({}, [baseDevConfig, {
  environmentName: 'Prism QA Environment',
  ionicEnvName: 'qa',
}]);



// WEBPACK FOOTER //
// ./src/app/environment-variables/base/qa.config.ts